import React from "react";

const portfolio = {
  title: "Fana Resort — Luxury Villas & Retreat Experience",
  description:
    "Developed a sophisticated website for Fana Resort, a luxury destination offering private villas, fine dining, and curated experiences. The platform highlights their stunning accommodations, world-class hospitality, and unique blend of comfort and nature.",
  categories: ["Hospitality", "Travel", "Luxury"],
  date: "April 2025",
  task:
    "Design and develop a responsive website that showcases Fana Resort’s villas, services, and activities, while providing an intuitive booking experience for international guests.",
  role: ["Web Development", "UI/UX Design", "SEO Optimization"],
  client: "Fana Resort",
  categoryYear: "Hospitality · 2025",
  liveSite: "https://fanaresort.com/",
  gallery: [
    "/img/case-4.jpg"
  ]
};

const PortfolioSingleFanaResort = () => (
  <section className="content">
    <div className="container">
      <div className="row justify-content-between">
        <div className="col-12 col-lg-5">
          <div className="heading">
            <div className="portfolio-meta d-flex align-items-center">
              <div className="portfolio-terms">
                {portfolio.categories.map((category, index) => (
                  <a key={index} className="terms" href="/portfolio">
                    {category}
                  </a>
                ))}
              </div>
              <span className="date">{portfolio.date}</span>
            </div>
            <h2>{portfolio.title}</h2>
            <p>{portfolio.description}</p>
          </div>
        </div>
        <div className="col-12 col-lg-6 items portfolio-meta mt-3 mt-md-0">
          <div className="task">
            <h6 className="title mb-3">Task</h6>
            <span className="details">{portfolio.task}</span>
          </div>
          <div className="content item d-flex flex-column flex-md-row justify-content-between">
            <div className="role">
              <h6 className="title mt-0 mb-1 mb-md-3">Role/Services</h6>
              <div className="portfolio-terms">
                {portfolio.role.map((role, index) => (
                  <a key={index} className="terms" href="/portfolio">
                    {role}
                  </a>
                ))}
              </div>
            </div>
            <div className="client my-3 my-md-0">
              <h6 className="title mt-0 mb-1 mb-md-3">Client</h6>
              <span>{portfolio.client}</span>
            </div>
            <div className="category">
              <h6 className="title mt-0 mb-1 mb-md-3">Category &amp; Year</h6>
              <span>{portfolio.categoryYear}</span>
            </div>
          </div>
          <div className="socials item">
            <a
              className="nav-link d-inline-flex swap-icon ms-0"
              href={portfolio.liveSite}
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Site <i className="icon bi bi-arrow-right-short"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="row portfolio-content items">
        <div className="col-12">
          {portfolio.gallery.map((img, index) => (
            <div key={index} className="item">
              <img
                src={img}
                alt={`Fana Resort gallery image ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default PortfolioSingleFanaResort;
